export default __webpack_public_path__ + "static/media/BG_2022_AGC.e1435b6f.jpg";